// File: types/esmStock.ts
export interface PriceData {
  entry_date: string | null;
  esm_state_price: number | null;
  current_price: number | null;
  price_change_percentage: number | null;
  current_date: string | null;
  esm_state_date: string | null;
}

export interface ESMStockListItemFE {
  isin: string;
  stock_name: string;
  industry_name: string | null;
  trading_view_navlink: string;
  screener_navlink: string;
  nse_code: string;
  bse_code: string;
  stock_code: string;
  current_state: number | null;
  current_state_date: string | null;
  current_state_transaction_type: string | null;
  days_spent_in_current_state: number | null;
  days_spent_in_esm: number | null;
  prediction_type: string | null;
  predicted_transition_date: string | null;
  reason: string | null;
  second_last_state: number | null;
  second_last_state_date: string | null;
  second_last_state_transaction_type: string | null;
  current_market_price: number | null;
  market_cap: number | null;
  price_to_earning: number | null;
  price_data?: PriceData;
}
export enum ESMTransactionType {
  entry = 'entry',
  exit = 'exit',
  moved_up = 'moved_up',
  moved_down = 'moved_down',
}
export interface ESMStockFilterOptions {
  stock_name?: string;
  start_date?: string;
  end_date?: string;
  transaction_type?: string;
  is_prediction?: boolean;
  is_sme?: boolean;
  should_put_price_filter?: boolean;
  listing_types?: string;
  watchlists?: Array<{ id: string; name: string; number_of_stocks: number }>;
}

